// SerpAPI-Adapter. V1: useSerpApi.js — direct call zur SerpAPI mit env-Key.
// V3-Refactor: durch unseren Hono-Worker geroutet via `/serp/search` Route
// (keine API-Keys im Browser).

import { apiFetch } from './api';

export interface SerpSearchResult {
  organic_results?: Array<{ title: string; link?: string; snippet?: string }>;
  organic?: Array<{ title: string; link?: string; snippet?: string }>;
}

/**
 * Sucht via SerpAPI durch den V3-Worker. Returns null bei Fehler.
 */
export async function searchWeb(
  query: string,
  accessToken?: string,
): Promise<SerpSearchResult | null> {
  if (!query.trim()) return null;
  try {
    return await apiFetch<SerpSearchResult>('/serp/search', {
      method: 'POST',
      accessToken: accessToken ?? null,
      json: { query },
    });
  } catch {
    return null;
  }
}
